import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { generateDataTestidAttribute } from '../../services/testid-service';
import { emptyObject } from 'ui-components/default-props/empty';

import styles from './modal.less';

export const Modal = ({ className = '', children, size = 'custom', style = emptyObject, modalHeaderId, ...props }) => (
  <div
    {...generateDataTestidAttribute(props['data-testid'])}
    aria-labelledby={modalHeaderId}
    className={classNames(styles.modal, className, styles[size])}
    role='dialog'
    style={style}
  >
    <div className={styles['modal-content']}>{children}</div>
  </div>
);

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  size: PropTypes.oneOf(['custom', 'small', 'medium', 'large']),
  style: PropTypes.object,
  modalHeaderId: PropTypes.string,
};
